if (!customElements.get("rafteltech-pagination")) {
  class RafteltechPagination extends HTMLElement {
    constructor() {
      super();
      this.selectors = {
        currentItems: ".rtlp-start",
        totalItems: ".rtlp-total",
        loadMore: ".rtlp-load-more"
      };
    }

    connectedCallback() {
      const _this = this;
      this.updateTotals();
      this.attachEvents();
    }

    updateTotals() {
      const startHtml = this.querySelector(this.selectors.currentItems);
      const totalHtml = this.querySelector(this.selectors.totalItems);
      if (startHtml && totalHtml) {
        const newSize = parseInt(this.dataset.pageSize);
        const newOffset = parseInt(this.dataset.offset);
        const newTotal = parseInt(this.dataset.total);
        startHtml.innerHTML = newSize + newOffset;
        totalHtml.innerHTML = newTotal;
        console.log(newSize + newOffset, newTotal);
        if (newSize + newOffset >= newTotal) {
          this.querySelector(this.selectors.loadMore).style.display = "none";
        }
      }
    }

    loadMore() {
      // disable button
      const _this = this;
      this.querySelector(this.selectors.loadMore).setAttribute("disabled", "disabled");
      // get html from new page and append to current page
      console.log(this.dataset.next);
      fetch(this.dataset.next)
        .then((response) => {
          console.log(response);
          return response.text();
        })
        .then((html) => {
          console.log(html);
          const parser = new DOMParser();
          const doc = parser.parseFromString(html, "text/html");
          const newItems = doc.querySelector(".rtlp-items");

          document.querySelector(".rtlp-items").appendChild(newItems);
          _this.querySelector(_this.selectors.loadMore).removeAttribute("disabled");
          const newPagination = doc.querySelector("rafteltech-pagination");
          _this.updateUrlState();
          _this.dataset.next = newPagination.dataset.next;
          _this.dataset.offset = newPagination.dataset.offset;
          _this.dataset.total = newPagination.dataset.total;
          _this.updateTotals();
        });
    }

    updateUrlState() {
      const nextUrl = this.dataset.next;
      window.history.pushState({}, "", nextUrl);
    }


    attachEvents() {
      const _this = this;
      this.querySelector(this.selectors.loadMore).addEventListener("click", function() {
        _this.loadMore();
      });
    }
  }

  customElements.define("rafteltech-pagination", RafteltechPagination);
}
